'use strict';

function GridMiddleToolbarDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    transclude: true,
    scope: true,
    template: require('../templates/grid-middle-toolbar.html')
  };
}
GridMiddleToolbarDirective.$inject = [];
module.exports = GridMiddleToolbarDirective;